(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["optisave-prescription-configurator"] && !Shopify.designMode) return;
  try {
    class OptisaveRxConfigurator extends HTMLElement {
    connectedCallback() {
      this.dialog = this.querySelector('[data-rx-dialog]');
      this.form = document.getElementById(this.dataset.formId);
      this.step = 1;
      this.configured = false;
      this.submitting = false;
      this.configurationId = '';
      this.openButtons = this.querySelectorAll('[data-rx-open]');
      this.error = this.querySelector('[data-rx-error]');
      this.fileInput = this.querySelector('[data-rx-file]');
      this.openButtons.forEach((button) => button.addEventListener('click', () => this.open()));
      this.querySelector('[data-rx-close]')?.addEventListener('click', () => this.close());
      this.querySelector('[data-rx-back]')?.addEventListener('click', () => this.back());
      this.querySelector('[data-rx-next]')?.addEventListener('click', () => this.next());
      this.querySelector('[data-rx-submit]')?.addEventListener('click', () => this.finalize());
      this.dialog?.addEventListener('click', (event) => {
        if (event.target === this.dialog) this.close();
      });
      this.querySelectorAll('input[type="radio"]').forEach((input) => {
        input.addEventListener('change', () => this.handleChoice(input));
      });
      this.fileInput?.addEventListener('change', () => {
        const file = this.fileInput.files?.[0];
        const name = this.querySelector('[data-rx-file-name]');
        if (name) name.textContent = file?.name || '';
      });
      this.form?.addEventListener('submit', (event) => this.handleFormSubmit(event), true);
      this.update();
    }

    get use() {
      return this.querySelector('input[name^="rx-use-"]:checked')?.value || '';
    }

    get method() {
      return this.querySelector('input[name^="rx-method-"]:checked')?.value || '';
    }

    get lensInput() {
      return this.querySelector('input[name^="rx-lens-"]:checked');
    }

    get pdType() {
      return this.querySelector('input[name^="rx-pd-type-"]:checked')?.value || 'single';
    }

    open() {
      if (!this.dialog) return;
      this.clearError();
      if (!this.dialog.open) this.dialog.showModal();
      requestAnimationFrame(() => this.querySelector(`[data-rx-step="${this.step}"] input`)?.focus());
    }

    close() {
      this.dialog?.close();
    }

    handleChoice(input) {
      if (input.name.startsWith('rx-method-')) {
        const upload = input.value === 'upload';
        this.querySelector('[data-rx-upload-panel]').hidden = !upload;
        this.querySelector('[data-rx-manual-panel]').hidden = upload;
        if (this.fileInput) this.fileInput.disabled = !upload;
      }
      if (input.name.startsWith('rx-pd-type-')) {
        const dual = input.value === 'dual';
        this.querySelector('[data-rx-pd-single]').hidden = dual;
        this.querySelector('[data-rx-pd-dual]').hidden = !dual;
      }
      if (input.name.startsWith('rx-use-')) {
        const reading = input.value === 'reading';
        this.querySelectorAll('[data-rx-add-heading], [data-rx-add-cell]').forEach((cell) => {
          cell.hidden = !reading;
        });
      }
      this.clearError();
    }

    next() {
      if (!this.validateStep()) return;
      if (this.step === 1 && this.use === 'frame-only') {
        this.step = 4;
      } else if (this.step === 1 && this.use === 'non-prescription') {
        this.step = 3;
      } else {
        this.step = Math.min(4, this.step + 1);
      }
      this.update();
    }

    back() {
      if (this.step === 4 && this.use === 'frame-only') {
        this.step = 1;
      } else if (this.step === 4 && this.use === 'non-prescription') {
        this.step = 3;
      } else if (this.step === 3 && this.use === 'non-prescription') {
        this.step = 1;
      } else {
        this.step = Math.max(1, this.step - 1);
      }
      this.clearError();
      this.update();
    }

    validateStep() {
      if (this.step === 1 && !this.use) return this.showError(this.dataset.errorUse);
      if (this.step === 2) {
        if (!this.method) return this.showError(this.dataset.errorMethod);
        if (this.method === 'upload') {
          const file = this.fileInput?.files?.[0];
          if (!file) return this.showError(this.dataset.errorUpload);
          if (file.size > 10485760) return this.showError(this.dataset.errorFileSize);
        }
        if (this.method === 'manual' && !this.validateManual()) return false;
      }
      if (this.step === 3) {
        if (!this.lensInput) return this.showError(this.dataset.errorLens);
        if (this.lensInput.dataset.pricePending === 'true') return this.showError(this.dataset.errorPricing);
      }
      return true;
    }

    validateManual() {
      const required = ['od_sph', 'os_sph'];
      if (this.use === 'reading') required.push('od_add', 'os_add');
      for (const key of required) {
        const input = this.querySelector(`[data-rx-field="${key}"]`);
        if (!input?.value || !input.checkValidity()) return this.showError(this.dataset.errorManual);
      }
      for (const eye of ['od', 'os']) {
        const cyl = this.querySelector(`[data-rx-field="${eye}_cyl"]`);
        const axis = this.querySelector(`[data-rx-field="${eye}_axis"]`);
        if (cyl?.value && Number(cyl.value) !== 0 && (!axis?.value || !axis.checkValidity())) {
          return this.showError(this.dataset.errorManual);
        }
      }
      if (this.pdType === 'single') {
        const pd = this.querySelector('[data-rx-field="pd_single"]');
        if (!pd?.value || !pd.checkValidity()) return this.showError(this.dataset.errorPd);
      } else {
        for (const key of ['pd_right', 'pd_left']) {
          const pd = this.querySelector(`[data-rx-field="${key}"]`);
          if (!pd?.value || !pd.checkValidity()) return this.showError(this.dataset.errorPd);
        }
      }
      return true;
    }

    update() {
      this.querySelectorAll('[data-rx-step]').forEach((section) => {
        section.hidden = Number(section.dataset.rxStep) !== this.step;
      });
      this.querySelectorAll('[data-rx-progress]').forEach((item) => {
        const step = Number(item.dataset.rxProgress);
        item.classList.toggle('is-active', step === this.step);
        item.classList.toggle('is-complete', step < this.step);
      });
      const back = this.querySelector('[data-rx-back]');
      const next = this.querySelector('[data-rx-next]');
      const submit = this.querySelector('[data-rx-submit]');
      back.hidden = this.step === 1;
      next.hidden = this.step === 4;
      submit.hidden = this.step !== 4;
      if (this.step === 4) this.renderReview();
      this.querySelector(`[data-rx-step="${this.step}"]`)?.scrollIntoView({ block: 'nearest' });
    }

    renderReview() {
      const useInput = this.querySelector('input[name^="rx-use-"]:checked');
      const methodInput = this.querySelector('input[name^="rx-method-"]:checked');
      const lens = this.lensInput;
      this.querySelector('[data-rx-review-use]').textContent =
        useInput?.closest('label')?.querySelector('strong')?.textContent?.trim() || '—';
      this.querySelector('[data-rx-review-method]').textContent =
        this.use === 'frame-only' || this.use === 'non-prescription'
          ? this.dataset.labelNotRequired
          : methodInput?.value === 'upload'
            ? this.dataset.labelUpload
            : this.dataset.labelManual;
      this.querySelector('[data-rx-review-lens]').textContent =
        this.use === 'frame-only' ? this.dataset.labelNotRequired : lens?.dataset.lensTitle || '—';
      this.querySelector('[data-rx-review-price]').textContent =
        this.use === 'frame-only'
          ? this.dataset.labelNotRequired
          : lens?.closest('label')?.querySelector('.optisave-rx__price')?.textContent?.trim() || '—';
      const requiresConsent = this.use === 'distance' || this.use === 'reading';
      const consentPanel = this.querySelector('[data-rx-consent-panel]');
      if (consentPanel) consentPanel.hidden = !requiresConsent;
    }

    finalize() {
      const consent = this.querySelector('[data-rx-consent]');
      const requiresConsent = this.use === 'distance' || this.use === 'reading';
      if (requiresConsent && !consent?.checked) return this.showError(this.dataset.errorConsent);
      if (this.use !== 'frame-only' && (!this.lensInput || this.lensInput.dataset.pricePending === 'true')) {
        return this.showError(this.dataset.errorPricing);
      }
      this.configurationId = globalThis.crypto?.randomUUID?.() || `rx-${Date.now()}-${Math.random().toString(16).slice(2)}`;
      this.writeProperties();
      this.configured = true;
      const selection = this.querySelector('[data-rx-selection]');
      const selectionText = this.querySelector('[data-rx-selection-text]');
      if (selectionText) {
        const lens = this.use === 'frame-only' ? this.dataset.labelNotRequired : this.lensInput?.dataset.lensTitle;
        selectionText.textContent = `${this.labelForUse()} · ${lens}`;
      }
      if (selection) selection.hidden = false;
      this.close();
      this.form?.requestSubmit();
    }

    labelForUse() {
      return this.querySelector('input[name^="rx-use-"]:checked')?.closest('label')?.querySelector('strong')?.textContent?.trim() || '';
    }

    writeProperties() {
      this.removeGeneratedProperties();
      this.addProperty('_Rx configuration ID', this.configurationId);
      this.addProperty('Lens use', this.labelForUse());
      this.addProperty('Lens package', this.use === 'frame-only' ? 'Frame only' : this.lensInput?.dataset.lensTitle || '');
      if (this.use === 'distance' || this.use === 'reading') {
        this.addProperty('Prescription method', this.method === 'upload' ? this.dataset.labelUpload : this.dataset.labelManual);
        if (this.method === 'manual') {
          const names = {
            od_sph: '_Right SPH',
            od_cyl: '_Right CYL',
            od_axis: '_Right AXIS',
            od_add: '_Right ADD',
            os_sph: '_Left SPH',
            os_cyl: '_Left CYL',
            os_axis: '_Left AXIS',
            os_add: '_Left ADD',
            pd_single: '_PD',
            pd_right: '_Right PD',
            pd_left: '_Left PD'
          };
          Object.entries(names).forEach(([key, name]) => {
            const input = this.querySelector(`[data-rx-field="${key}"]`);
            if (input?.value && (this.pdType === 'single' || !key.endsWith('single')) && (this.pdType === 'dual' || !key.startsWith('pd_') || key === 'pd_single')) {
              this.addProperty(name, input.value);
            }
          });
        }
      }
      if (this.use === 'distance' || this.use === 'reading') {
        this.addProperty('_Prescription consent', 'Confirmed');
      }
    }

    addProperty(name, value) {
      if (!this.form || !value) return;
      const input = document.createElement('input');
      input.type = 'hidden';
      input.name = `properties[${name}]`;
      input.value = value;
      input.dataset.rxGenerated = 'true';
      this.form.append(input);
    }

    removeGeneratedProperties() {
      this.form?.querySelectorAll('[data-rx-generated]').forEach((input) => input.remove());
    }

    handleFormSubmit(event) {
      if (this.submitting) return;
      if (!this.configured) {
        event.preventDefault();
        event.stopImmediatePropagation();
        this.open();
        return;
      }
      event.preventDefault();
      event.stopImmediatePropagation();
      this.submitConfiguredOrder();
    }

    async submitConfiguredOrder() {
      if (!this.form || this.submitting) return;
      this.submitting = true;
      this.setBusy(true);
      let frameKey = '';
      try {
        const frameData = new FormData(this.form);
        const frameResponse = await fetch(`${this.dataset.rootUrl}cart/add.js`, {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: frameData
        });
        const frame = await frameResponse.json();
        if (!frameResponse.ok) throw new Error(frame.description || frame.message || this.dataset.errorCart);
        frameKey = frame.key;
        if (this.use !== 'frame-only') {
          const lensResponse = await fetch(`${this.dataset.rootUrl}cart/add.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({
              items: [{
                id: Number(this.lensInput.value.replace(/\D/g, '')),
                quantity: Number(frameData.get('quantity')) || 1,
                properties: {
                  '_Rx configuration ID': this.configurationId,
                  '_Frame product': this.dataset.productTitle
                }
              }]
            })
          });
          const lens = await lensResponse.json();
          if (!lensResponse.ok) throw new Error(lens.description || lens.message || this.dataset.errorCart);
        }
        window.location.assign(`${this.dataset.rootUrl}cart`);
      } catch (error) {
        if (frameKey) {
          await fetch(`${this.dataset.rootUrl}cart/change.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ id: frameKey, quantity: 0 })
          }).catch(() => {});
        }
        this.showError(error.message || this.dataset.errorCart);
        this.open();
        this.submitting = false;
        this.setBusy(false);
      }
    }

    setBusy(busy) {
      this.querySelectorAll('button').forEach((button) => {
        button.disabled = busy;
      });
      const nativeButton = this.form?.querySelector('button[name="add"]');
      if (nativeButton) nativeButton.disabled = busy;
    }

    showError(message) {
      if (!this.error) return false;
      this.error.textContent = message;
      this.error.hidden = false;
      return false;
    }

    clearError() {
      if (!this.error) return;
      this.error.textContent = '';
      this.error.hidden = true;
    }
  }

  if (!customElements.get('optisave-rx-configurator')) {
    customElements.define('optisave-rx-configurator', OptisaveRxConfigurator);
  }
  } catch(e) { console.error(e); }
})();

})();
